/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import PatientInformation from 'DesignSystem/PatientInformation/index'
import Popover from 'DesignSystem/Popover/index'
import PopoverContent from 'DesignSystem/Popover/PopoverContent/index'
import PopoverTrigger from 'DesignSystem/Popover/PopoverTrigger/index'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonIcon from 'DesignSystem/TysiaButton/TysiaButtonIcon/index'
import Tysiav2InfoFilled from 'DesignSystem/Svgs/Tysiav2InfoFilled/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Calendar/New/AppointmentOverlay/Content/New/PatientInfo/Content"
  
}) {
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let appointmentOverlayPatientIdValueData = fromData.useDataValue({ viewPath,
context: 'appointment_overlay',
path: 'patient_id',
})
  return (<React.Fragment
>
<Popover
  viewPath={`${viewPath}/Popover`}
>
{childProps => (
<React.Fragment>
<PopoverTrigger
{...childProps}
  viewPath={`${viewPath}/PopoverTrigger`}
>
{childProps => (
<TysiaButton
{...childProps}
  viewPath={`${viewPath}/TysiaButton`}
 size="small"
 type="ghost"
>
{childProps => (
<TysiaButtonIcon
{...childProps}
  viewPath={`${viewPath}/TysiaButtonIcon`}
>
{childProps => (
<Tysiav2InfoFilled
{...childProps}
  viewPath={`${viewPath}/Tysiav2InfoFilled`}
 width={13}
 height={13}
 fill2={dtColorsNeutral400}
/>
)}
</TysiaButtonIcon>
)}
</TysiaButton>
)}
</PopoverTrigger>
<PopoverContent
{...childProps}
  viewPath={`${viewPath}/PopoverContent`}
>
{childProps => (
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 style={{'--bc-1-Z1Yf8zk': dtColorsWhite,'--bc-2-Z1Yf8zk': dtColorsNeutral200,'--btlr-3-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btrr-4-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bblr-5-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bbrr-6-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pt-7-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pb-8-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pl-9-Z1Yf8zk': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pr-10-Z1Yf8zk': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--g-11-Z1Yf8zk': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block new-shadow ${styles.Vertical}`}
>
<PatientInformation
  viewPath={`${viewPath}/PatientInformation`}
 data="appointment_overlay.patient_id"
 patientId={appointmentOverlayPatientIdValueData}
/>
</div>
)}
</PopoverContent>
</React.Fragment>
)}
</Popover>
{children}
</React.Fragment>)
}